<template>
  <b-container class="p-4">
    <b-card class="text-center">
      <h2>
        Dziękujemy za przesłanie ankiety!
      </h2>

      <img
        :src="brandLogo"
        alt="logo"
        style="width: 160px; display: block; margin: 2rem auto 1rem"
      >
    </b-card>
  </b-container>
</template>

<script>
import { BContainer, BCard } from 'bootstrap-vue'
import { brandLogo } from '@/helpers/brandLogo'

export default {
  components: { BContainer, BCard },
  data() {
    return {
      brandLogo,
    }
  },
}
</script>

<style>

</style>
